import React, { useEffect } from 'react'
import { FaRegEdit } from "react-icons/fa";
import {Link} from "react-router-dom"

export default function HomeProfile() {
  let [data, setData] = React.useState([]);
   
  const getData = async () => {
   try {
    let res = await fetch ("http://34.228.14.188:8000/api/user/"+localStorage.getItem("userid"),{
      method:"GET",
      headers:{
        "Content-type":"application/json",
      }
    })
    res = await res.json()
    if(res.result==="Done"){
      setData(res.data)
    }
    
   } catch (error) {
   }
      
  }

  useEffect(()=>{
    getData()
  },[])

  return (
 <>
   <div className="col-md-8 col-12 col-sm-8">
                <div className="admin-home">
                     <div className="admin-heading">
                        {
                            localStorage.getItem("login")?(localStorage.getItem("role")==="@u_%&@!==?*&@!"?
                            <h3>USER PROFILE <Link to="/update-profile"><FaRegEdit className='float-end mx-2' /></Link> </h3>:
                          <h3>ADMIN PROFILE <Link to="/update-profile"><FaRegEdit className='float-end mx-2' /></Link> </h3>
                        
                        )
                        :""
                        }
                        </div>
                        <table className='table-bordered table'>
                          <tbody>
                            <tr>
                              <th>Name </th>
                              <td>{data.name}</td>
                            </tr>
                            <tr>
                              <th>E-Mail</th>
                              <td>{data.email}</td>
                            </tr>
                            <tr>
                              <th>Phone No.</th>
                              <td>{data.phone}</td>
                            </tr>
                            <tr>
                              <th>Address </th>
                              <td>{data.address}</td>
                            </tr>
                           {
                            localStorage.getItem("login") && localStorage.getItem("role")==="@u_%&@!==?*&@!"?
                            <tr>
                            <th>UserName </th>
                            <td>{data.username}</td>
                          </tr>:
                           <tr>
                           <th>Role </th>
                           <td>{localStorage.getItem("role")==="@A*_s&_k!=!@h!-%"?"Admin":"User"}</td>
                         </tr>
                            
                           }
                          </tbody>
                        </table>
                     
                </div>

          </div>
 </>
  )
}
